// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw線上終極版',
  fileSizeLimitTitle: '免費帳戶的檔案大小不能超過20MB。',
  freeTimesLimitTitle: '免費帳戶的試用今天已用完。',
  freeImgCutoutTimesLimitTitle:
    '去除背景功能今日試用機會已用完，升級至Pro以訪問所有高級功能',
  total: '全部的',
  enterCode: '輸入碼',
  signUpToPurchaseBtn: '註冊並去購買',
  goPurchseBtn: '去購買',
  saveTips: '最多可節省{{num}}%',
  discount: '折扣',
  priceWeek: 'NT$320',
  priceMonth: 'NT$240',
  priceYear: 'NT$120',
  billedMonth: 'NT$959 月度訂閱費用',
  billedYear: 'NT$5799 年度訂閱費用',
  monthly: '每月',
  yearly: '每年的',
  weekly: '每周',
  week: '週',
  AlreadySubscribe: '已經訂閱？',
  vipTips1: '沒有檔案大小限制',
  vipTips2: '處理檔案數量無限制',
  vipTips3: '無限制地更改影象背景',
  vipTips4: '使用所有免費工具和高階功能',
  purchaseTips: '自動續訂並隨時取消。',
  tips: '提示：',
  promoCodeInvalidTips: '你的優惠碼無效',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
